{
  "iconsList1": {
    "icon": {
      "url": "/icons/icon_point.svg",
      "alternative": "",
      "width": "32",
      "height": "32"
    },
    "type": "dot",
    "layout": "row",
    "items": [
      {
        "title": "Asystent celu"
      },
      {
        "title": "Dedykowany opiekun"
      },
      {
        "title": "Wspierające programy"
      },
      {
        "title": "Dashboard HR"
      }
    ]
  },
  "iconsList2": {
    "icon": {
      "url": "/icons/icon_point_blue.svg",
      "alternative": "",
      "width": "32",
      "height": "32"
    },
    "type": "dot",
    "layout": "row",
    "items": [
      {
        "title": "Rozwiązanie kafeteryjne"
      },
      {
        "title": "Grywalizacja i motywacja"
      },
      {
        "title": "Intranet 2.0"
      },
      {
        "title": "ePodpis"
      }
    ]
  },
  "iconsList3": [
    {
      "text": "Zmierz poziom wellbeingu w firmie i poznaj kluczowe obszary wymagające wsparcia",
      "icon": {
        "url": "/icons/icon_search.svg",
        "alternative": "",
        "width": "72",
        "height": "72"
      }
    },
    {
      "text": "Skorzystaj z kompleksowego wsparcia ekspertów i doradców, dobierz właściwe narzędzia",
      "icon": {
        "url": "/icons/icon_person.svg",
        "alternative": "",
        "width": "72",
        "height": "72"
      }
    },
    {
      "text": "Obserwuj, jak dopasowana strategia wellbeingowa buduje mocny i odporny zespół",
      "icon": {
        "url": "/icons/icon_hands.svg",
        "alternative": "",
        "width": "72",
        "height": "72"
      }
    }
  ],
  "iconsList4": {
    "icon": {
      "url": "/icons/icon_checkmark.svg",
      "alternative": "",
      "width": "40",
      "height": "40"
    },
    "type": "checkmark",
    "layout": "row",
    "items": [
      {
        "title": "Ocenisz poziom dobrostanu firmy"
      },
      {
        "title": "Wsłuchasz się w pracowników i ich potrzeby"
      },
      {
        "title": "Stworzysz dopasowaną strategię wellbeingową"
      },
      {
        "title": "Wesprzesz zespół dobranymi narzędziami, usługami i programami"
      }
    ]
  },
  "logos": [
    {
      "url": "/icons/company_1.svg",
      "alternative": "",
      "width": "72",
      "height": "72"
    },
    {
      "url": "/icons/company_2.svg",
      "alternative": "",
      "width": "72",
      "height": "72"
    },
    {
      "url": "/icons/company_3.svg",
      "alternative": "",
      "width": "72",
      "height": "72"
    },
    {
      "url": "/icons/company_4.svg",
      "alternative": "",
      "width": "72",
      "height": "72"
    },
    {
      "url": "/icons/company_5.svg",
      "alternative": "",
      "width": "72",
      "height": "72"
    }
  ],
  "iconsList5": [
    {
      "text": "Zbadajmy potrzeby Twojej firmy",
      "icon": {
        "url": "/icons/icon-4.svg",
        "alternative": "",
        "width": "72",
        "height": "72"
      }
    },
    {
      "text": "Zbudujmy strategię wellbeingową dopasowaną do potrzeb organizacji",
      "icon": {
        "url": "/icons/icon-5.svg",
        "alternative": "",
        "width": "72",
        "height": "72"
      }
    },
    {
      "text": "Dobierzemy skuteczne narzędzia i programy",
      "icon": {
        "url": "/icons/icon-6.svg",
        "alternative": "",
        "width": "72",
        "height": "72"
      }
    },
    {
      "text": "Zmierzymy i zweryfikujemy rezultaty",
      "icon": {
        "url": "/icons/icon-7.svg",
        "alternative": "",
        "width": "72",
        "height": "72"
      }
    }
  ],
  "logos2": [
    {
      "url": "/icons/company_berlitz.svg",
      "alternative": "",
      "width": "72",
      "height": "72"
    },
    {
      "url": "/icons/company_8.svg",
      "alternative": "",
      "width": "72",
      "height": "72"
    },
    {
      "url": "/icons/company_lerni.png",
      "alternative": "",
      "width": "72",
      "height": "72"
    },
    {
      "url": "/icons/company_10.svg",
      "alternative": "",
      "width": "72",
      "height": "72"
    }
  ],
  "iconsList6": [
    {
      "title": "eTravelpass",
      "icon": {
        "url": "/icons/earth-2.svg",
        "link": "https://benefitsystems.pl/dla-ciebie/etravelpass/"
      }
    },
    {
      "title": "MultiBilet",
      "icon": {
        "url": "/icons/ticket-1.svg",
        "link": "https://benefitsystems.pl/dla-ciebie/multibilet/"
      }
    }
  ],
  "iconsList7": {
    "icon": {
      "url": "/icons/icon_checkmark_blue.svg",
      "alternative": "",
      "width": "32",
      "height": "32"
    },
    "type": "checkmark-blue",
    "layout": "row",
    "items": [
      {
        "title": "Nowoczesna automatyzacja, która pozwala zaoszczędzić czas"
      },
      {
        "title": "Intuicyjne narzędzia, niewymagające zaawansowanej wiedzy technologicznej"
      },
      {
        "title": "Elastyczna oferta modułów dopasowana do potrzeb firmy"
      },
      {
        "title": "Intuicyjne raportowanie i pełen monitoring dla HR"
      },
      {
        "title": "Szeroka oferta świadczeń i elastyczny model finansowania, również ze środków ZFŚS"
      },
      {
        "title": "Pełne wsparcie użytkownika dzięki infolinii dostępnej 7 dni w tygodniu"
      }
    ]
  },
  "logos3": [
    {
      "url": "/icons/company_15.svg",
      "alternative": "",
      "width": "72",
      "height": "72"
    },
    {
      "url": "/icons/company_12.svg",
      "alternative": "",
      "width": "72",
      "height": "72"
    },
    {
      "url": "/icons/company_13.svg",
      "alternative": "",
      "width": "72",
      "height": "72"
    },
    {
      "url": "/icons/company_14.svg",
      "alternative": "",
      "width": "72",
      "height": "72"
    },
    {
      "url": "/icons/company_11.svg",
      "alternative": "",
      "width": "72",
      "height": "72"
    }
  ],
  "list1": [
    {
      "title": "Dostępność",
      "text": "Wstęp do <span>ponad 15 000 obiektów</span> łącznie w Polsce i za granicą"
    },
    {
      "title": "Różnorodność",
      "text": "<span>ponad 55 różnych aktywności</span>, w tym sezonowe, np. deska SUP, kajaki czy łyżwy"
    },
    {
      "title": "Wiedza i motywacja",
      "text": "Treningi online, materiały wideo dla początkujących, treści edukacyjne, motywacyjne i inspiracyjne tworzone przez ekspertów"
    }
  ],
  "iconsList10": {
    "icon": {
      "url": "/icons/icon_point_blue.svg",
      "alternative": "",
      "width": "32",
      "height": "32"
    },
    "type": "dot",
    "layout": "column",
    "items": [
      {
        "title": "Szybkie wejście do obiektów bez dokumentu tożsamości"
      },
      {
        "title": "Dostęp do obiektów zagranicznych"
      },
      {
        "title": "Wyszukiwanie obiektów w kilka sekund"
      },
      {
        "title": "Proste zarządzanie kartami dla dzieci i bliskich"
      },
      {
        "title": "Informacje o nowościach i konkursach"
      }
    ]
  },
  "iconsList11": [
    {
      "text": "Wpłyniesz na budowanie zdrowych nawyków w organizacji, zapewniając dostęp do nowoczesnych narzędzi i usług",
      "icon": {
        "url": "/icons/icon-19.svg",
        "alternative": "",
        "width": "72",
        "height": "72"
      }
    },
    {
      "text": "Wzmocnisz pracowników w trosce o dobrostan psychiczny i fizyczny",
      "icon": {
        "url": "/icons/icon-20.svg",
        "alternative": "",
        "width": "72",
        "height": "72"
      }
    },
    {
      "text": "Umożliwisz ciągły rozwój zespołu, wykorzystując nowoczesne technologie, sprzyjające osiąganiu celów",
      "icon": {
        "url": "/icons/icon-21.svg",
        "alternative": "",
        "width": "72",
        "height": "72"
      }
    },
    {
      "text": "Zmniejszysz absencję w zespole dzięki kompleksowej profilaktyce zdrowia",
      "icon": {
        "url": "/icons/icon-22.svg",
        "alternative": "",
        "width": "72",
        "height": "72"
      }
    }
  ],
  "iconsList12": [
    {
      "text": "Określenie potrzeb",
      "subtext": "Inteligentny dobór programu spełniającego indywidualne potrzeby"
    },
    {
      "text": "Personalizowana zawartość",
      "subtext": "Dobór usług, konsultacji, webinarów i kursów dopasowany do celu"
    },
    {
      "text": "Wsparcie ekspertów",
      "subtext": "Pełna asysta i wskazówki opiekuna programu, indywidualne konsultacje ze specjalistami"
    },
    {
      "text": "Obserwacja efektów",
      "subtext": "Rozwój w oparciu o nowoczesne metody nauki i angażowania użytkowników"
    }
  ],
  "iconsList13": [
    {
      "text": "Pomiar",
      "subtext": "Zbadaj poziom wellbeingu w firmie"
    },
    {
      "text": "Strategia",
      "subtext": "Zbuduj z nami dopasowaną do organizacji strategię w oparciu o dane"
    },
    {
      "text": "Działanie",
      "subtext": "Dostarcz adekwatne produkty i rozwiązania wspierające kompleksowo pracowników"
    },
    {
      "text": "Efekty",
      "subtext": "Obserwuj, jak sprawdzone benefity i narzędzia poprawiają zdrowie i satysfakcję pracowników"
    }
  ]
}